import { reactive, watch, toRefs } from 'vue'
import { useMutation, useQuery, provideApolloClient } from '@vue/apollo-composable'
import { Notify } from 'quasar'
import { apolloClient } from 'boot/apollo'
import meQuery from '../graphql/me.gql'
import globalConfigurationQuery from '../graphql/globalConfigurationQuery.gql'
import loginMutation from '../graphql/loginMutation.gql'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
provideApolloClient(apolloClient)

const state = reactive({
  authModalVisible: false,
  authModalTab: 'LOGIN',
  showMobileDrawer: false,
  isLoggedIn: false,
  userDetailsLoaded: false,
  user: {
    firstName: null,
    lastName: null
  },
  accessToken: null,
  refreshToken: null,
  newUser: {
    firstName: null,
    lastName: null,
    email: null,
    password: null,
    passwordAgain: null,
    interest: 'PRIVATE'
  },
  loginEmail: null,
  loginPassword: null,
  showPortfolioUpload: false,
  showB2BContactPopup: false,
  trackingLink: null,
  globalConfiguration: null
})

const authUserFromTokens = async () => {
  try {
    const accesstokenLC = localStorage.getItem('accessToken')
    if (accesstokenLC) {
      const decoded = jwtDecode(accesstokenLC)
      const d = new Date(0)
      d.setUTCSeconds(decoded.exp)
      const expiresInMS = moment(d).diff(moment(), 'millisecond')
      if (expiresInMS < 0) {
        await logout(true)
        Notify.create({ type: 'info', message: 'Your token has expired, please log in again.', icon: 'fas fa-bell' })
        return
      }
      // if (expiresInMS <= 60000) {
      //   console.log('SHOULD REFRESH TOKEN')
      // }
      // console.log('Access token expires in', (expiresInMS / 1000) / 60)
      setTimeout(async () => {
        await refreshAccessToken()
      }, expiresInMS)
      state.accessToken = accesstokenLC
      state.refreshToken = localStorage.getItem('refreshToken')
      await apolloClient.resetStore()
      await loadUserProfile()
      if (state.authModalTab === 'LOGIN') {
        state.authModalVisible = false
      }
    }
  } catch (e) {
    console.log(e)
  }
}

const refreshAccessToken = async () => {
  // console.log('REFRESH ACCESS TOKEN')
}

const { mutate: performLogin, error: loginError } = useMutation(
  loginMutation,
  () => ({
    update: async (cache, { data: { login } }) => {
      state.accessToken = login.accessToken
      state.refreshToken = login.refreshToken
      localStorage.setItem('accessToken', login.accessToken)
      localStorage.setItem('refreshToken', login.refreshToken)
      await authUserFromTokens()
      if (state.authModalTab === 'LOGIN') {
        Notify.create({ type: 'positive', message: 'Du hast dich erfolgreich eingeloggt.', icon: 'fas fa-bell' })
      }
    }
  })
)

watch(loginError, newVal => {
  try {
    console.log('LOGIN MUTATION ERROR', newVal)
    if (newVal) {
      const errorMessage = newVal.message
      Notify.create({ type: 'info', message: errorMessage, icon: 'fas fa-bell' })
      if (errorMessage === 'Please verify your email address to be able to login.') {
        state.newUser.email = state.loginEmail
        state.authModalTab = 'TOKEN'
      }
    }
  } catch (e) {
    console.log(e)
  }
})

async function loadUserProfile () {
  try {
    state.isLoggedIn = true
    const res = await apolloClient.query({ query: meQuery })
    if (res && res.data && res.data.me) {
      state.user = JSON.parse(JSON.stringify(res.data.me))
      state.userDetailsLoaded = true
    }
  } catch (e) {
    console.log('USER PROFILE ERROR', JSON.parse(JSON.stringify(e)))
    await logout(true)
    Notify.create({ type: 'info', message: 'Your token has expired, please log in again.', icon: 'fas fa-bell' })
  }
}

watch(() => state.isLoggedIn, async value => {
  if (value) {
    await loadUserProfile()
  } else {
    await logout(true)
  }
})

const logout = async (hideMessage) => {
  try {
    state.authModalVisible = false
    state.isLoggedIn = false
    state.userDetailsLoaded = false
    state.accessToken = null
    state.refreshToken = null
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    await apolloClient.resetStore()
    if (!hideMessage) {
      Notify.create({ type: 'positive', message: 'Du hast dich erfolgreich ausgeloggt.' })
    }
  } catch (e) {
    console.log(e)
  }
}

const handleTrackingLink = async (query) => {
  try {
    if (query && query.utm_source && query.utm_campaign) {
      state.trackingLink = {
        utm_campaign: query.utm_campaign,
        utm_content: query.utm_content,
        utm_source: query.utm_source,
        utm_medium: query.utm_medium,
        utm_term: query.utm_term,
        openedAt: new Date()
      }
      localStorage.setItem('trackingLink', JSON.stringify(state.trackingLink))
    } else {
      let trackingLink = localStorage.getItem('trackingLink')
      if (trackingLink) {
        trackingLink = JSON.parse(trackingLink)
        state.trackingLink = trackingLink
      } else {
        state.trackingLink = null
        localStorage.removeItem('trackingLink')
      }
    }
  } catch (e) {
    console.log(e)
  }
}

const loadGlobalConfig = async () => {
  try {
    const res = await apolloClient.query({ query: globalConfigurationQuery })
    if (res && res.data && res.data.globalConfiguration) {
      state.globalConfiguration = res.data.globalConfiguration
    }
  } catch (e) {
    console.log('GE', JSON.parse(JSON.stringify(e)))
  }
}

export function useGlobalStore () {
  const isBrowser = typeof window !== 'undefined'
  const isProduction = process.env.NODE_ENV === 'production' && isBrowser
  // const isProduction = true
  return {
    ...toRefs(state),
    isBrowser,
    performLogin,
    logout,
    authUserFromTokens,
    isProduction,
    handleTrackingLink,
    loadGlobalConfig
  }
}
